import { render, staticRenderFns } from "./classStudent.vue?vue&type=template&id=3e4d5442&scoped=true"
import script from "./classStudent.vue?vue&type=script&lang=js"
export * from "./classStudent.vue?vue&type=script&lang=js"
import style0 from "./classStudent.vue?vue&type=style&index=0&id=3e4d5442&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4d5442",
  null
  
)

export default component.exports